import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ColorGraphicACP from '@features/trend-research/components/details/ColorGraphicsACP';
import DetailsContainer from '@features/trend-research/components/details/components/DetailsContainer';
import PageTitle from '@features/trend-research/components/details/components/PageTitle';
import Tabs from '@features/trend-research/components/details/components/Tabs';
import TrendResearchLayout from '@features/trend-research/components/details/components/TrendResearchLayout';
import Fabric from '@features/trend-research/components/details/Fabric';
import Theme from '@features/trend-research/components/details/Theme';
import { getTitle } from '@features/trend-research/utils/utils';

const tabMapping = {
	'key-fabric': 0,
	'key-color': 1,
	'key-graphics': 1,
	'key-prints': 1,
	'key-theme': 2
};
const reverseTabMapping = {
	0: 'key-fabric',
	1: 'key-color',
	2: 'key-theme'
};

const TrendResearchDetails = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const params = new URLSearchParams(location.search);
	const initialTabType = location?.state?.type;
	const { source } = location?.state || {};
	const tabs = [
		{ name: 'Fabric', disabled: source !== 'Brand' }, // Disable Fabric if source is not 'Brand'
		{ name: 'Color, Graphics & AOP', disabled: false },
		{ name: 'Theme', disabled: false }
	];

	const [activeTab, setActiveTab] = useState(tabMapping[initialTabType] ?? 0);
	const [tabType, setTabType] = useState(initialTabType ?? 'key-fabric');

	useEffect(() => {
		if (tabType && tabMapping[tabType] !== undefined) {
			setActiveTab(tabMapping[tabType]);
		}
	}, [tabType]);

	const handleTabClick = (index) => {
		setActiveTab(index);

		const newTabType = reverseTabMapping[index];

		if (newTabType) {
			setTabType(newTabType); // Set the local state to the new tab type

			navigate({
				search: params.toString(),
				state: { type: newTabType, source }
			});
		}
	};

	const renderTabContent = () => {
		switch (activeTab) {
			case 0:
				if (source === 'Brand') {
					return <Fabric />;
				}
				return null;
			case 1:
				return <ColorGraphicACP />;
			case 2:
				return <Theme />;

			default:
				return null;
		}
	};
	return (
		<>
			<TrendResearchLayout>
				<PageTitle title={getTitle(tabType)} source={source} />
				<Tabs tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />
			</TrendResearchLayout>
			<DetailsContainer>{renderTabContent()}</DetailsContainer>
		</>
	);
};

export default TrendResearchDetails;
